<template>
	<div class="row p-0">
		<!-- <div class="col-12 col-md-6 modal-widget-col">
			<div class="Tooltips-box">ویجت نمایش جدول قیمت ها در داشبورد</div>
			<div class="card">
				<i class="fa fa-money fa-rotate-35"></i>
				<div class="card-body text-center">
					<p class="card-icon "><i class="fa fa-money icon-md"></i></p>
					<h5 class="card-title ">جدول قیمت ها</h5>
					<a href="#" class="m-left tgju-btn tgju-btn-primary" @click.prevent="addWidget('price')"><i class="uil uil-plus-circle"></i> افزودن</a>
				</div>
			</div>
		</div> -->
		<div class="col-12 col-md-6 modal-widget-col">
			<div class="Tooltips-box">ویجت نمایش سامانه تکنیکال در داشبورد</div>
			<div class="card">
				<i class="uil uil-chart-line fa-rotate-35"></i>
				<div class="card-body text-center">
					<p class="card-icon "><i class="uil uil-chart-line icon-md"></i></p>
					<h5 class="card-title ">سامانه تکنیکال</h5>
					<a href="#" class="m-left tgju-btn tgju-btn-primary" v-tooltip.bottom="'افزودن به داشبورد'" @click.prevent="addWidget('trading-view')"><i class="uil uil-plus-circle"></i> افزودن</a>
				</div>
			</div>
		</div>
		<div class="col-12 col-md-6 modal-widget-col">
			<div class="Tooltips-box">ویجت نمایش نمودار در داشبورد</div>
			<div class="card">
				<i class="uil uil-chart fa-rotate-35"></i>
				<div class="card-body text-center">
					<p class="card-icon "><i class="uil uil-chart icon-md"></i></p>
					<h5 class="card-title ">نمودار</h5>
					<a href="#" class="m-left tgju-btn tgju-btn-primary" v-tooltip.bottom="'افزودن به داشبورد'" @click.prevent="addWidget('chart')"><i class="uil uil-plus-circle"></i> افزودن</a>
				</div>
			</div>
		</div>
		<div class="col-12 col-md-6 modal-widget-col">
			<div class="Tooltips-box">ویجت نمایش جدول قیمت‌ها در داشبورد</div>
			<div class="card">
				<i class="uil uil-list-ui-alt fa-rotate-35"></i>
				<div class="card-body text-center">
					<p class="card-icon "><i class="uil uil-list-ui-alt icon-md"></i></p>
					<h5 class="card-title ">جدول قیمت‌ها</h5>
					<a href="#" class="m-left tgju-btn tgju-btn-primary" v-tooltip.bottom="'افزودن به داشبورد'" @click.prevent="addWidget('watch-list')"><i class="uil uil-plus-circle"></i> افزودن</a>
				</div>
			</div>
		</div>
		<div class="col-12 col-md-6 modal-widget-col">
			<div class="Tooltips-box">ویجت نمایش جدیدترین اخبار در داشبورد</div>
			<div class="card">
				<i class="uil uil-newspaper fa-rotate-35"></i>
				<div class="card-body text-center">
					<p class="card-icon "><i class="uil uil-newspaper icon-md"></i></p>
					<h5 class="card-title ">اخبار</h5>
					<a href="#" class="m-left tgju-btn tgju-btn-primary" v-tooltip.bottom="'افزودن به داشبورد'" @click.prevent="addWidget('news')"><i class="uil uil-plus-circle"></i> افزودن</a>
				</div>
			</div>
		</div>
		<div class="col-12 col-md-6 modal-widget-col">
			<div class="Tooltips-box">ویجت نمایش نشان‌شده‌ها در داشبورد</div>
			<div class="card">
				<i class="uil uil-bookmark-full fa-rotate-35"></i>
				<div class="card-body text-center">
					<p class="card-icon "><i class="uil uil-bookmark-full icon-md"></i></p>
					<h5 class="card-title ">نشان‌شده‌ها</h5>
					<a href="#" class="m-left tgju-btn tgju-btn-primary" v-tooltip.bottom="'افزودن به داشبورد'" @click.prevent="addWidget('favorite')"><i class="uil uil-plus-circle"></i> افزودن</a>
				</div>
			</div>
		</div>
		<div class="col-12 col-md-6 modal-widget-col">
			<div class="Tooltips-box">ویجت نمایش یادداشت‌ها و اسناد در داشبورد</div>
			<div class="card">
				<i class="uil uil-notes fa-rotate-35"></i>
				<div class="card-body text-center">
					<p class="card-icon "><i class="uil uil-notes icon-md"></i></p>
					<h5 class="card-title ">یادداشت‌ها و اسناد</h5>
					<a href="#" class="m-left tgju-btn tgju-btn-primary" v-tooltip.bottom="'افزودن به داشبورد'" @click.prevent="addWidget('note')"><i class="uil uil-plus-circle"></i> افزودن</a>
				</div>
			</div>
		</div>
		<div class="col-12 col-md-6 modal-widget-col">
			<div class="Tooltips-box">ویجت نمایش تقویم اقتصادی در داشبورد</div>
			<div class="card">
				<i class="uil uil-calendar-alt fa-rotate-35"></i>
				<div class="card-body text-center">
					<p class="card-icon "><i class="uil uil-calendar-alt icon-md"></i></p>
					<h5 class="card-title ">تقویم اقتصادی</h5>
					<a href="#" class="m-left tgju-btn tgju-btn-primary" v-tooltip.bottom="'افزودن به داشبورد'" @click.prevent="addWidget('calendar')"><i class="uil uil-plus-circle"></i> افزودن</a>
				</div>
			</div>
		</div>
		<div class="col-12 col-md-6 modal-widget-col">
			<div class="Tooltips-box">ویجت نمایش وظایف روزانه در داشبورد</div>
			<div class="card">
				<i class="uil uil-list-ol-alt fa-rotate-35"></i>
				<div class="card-body text-center">
					<p class="card-icon "><i class="uil uil-list-ol-alt icon-md"></i></p>
					<h5 class="card-title ">وظایف روزانه</h5>
					<a href="#" class="m-left tgju-btn tgju-btn-primary" v-tooltip.bottom="'افزودن به داشبورد'" @click.prevent="addWidget('todo')"><i class="uil uil-plus-circle"></i> افزودن</a>
				</div>
			</div>
		</div>
		<div class="col-12 col-md-6 modal-widget-col">
			<div class="Tooltips-box">ویجت نمایش پست‌های ارسال‌شده در داشبورد</div>
			<div class="card">
				<i class="uil uil-file-graph fa-rotate-35"></i>
				<div class="card-body text-center">
					<p class="card-icon "><i class="uil uil-file-graph icon-md"></i></p>
					<h5 class="card-title "> پست‌های ارسال‌شده</h5>
					<a href="#" class="m-left tgju-btn tgju-btn-primary" v-tooltip.bottom="'افزودن به داشبورد'" @click.prevent="addWidget('my-posts')"><i class="uil uil-plus-circle"></i> افزودن</a>
				</div>
			</div>
		</div>
		<div class="col-12 col-md-6 modal-widget-col">
			<div class="Tooltips-box">ویجت نمایش ارسال‌های دوستان در داشبورد</div>
			<div class="card">
				<i class="uil uil-file-graph fa-rotate-35"></i>
				<div class="card-body text-center">
					<p class="card-icon "><i class="uil uil-file-graph icon-md"></i></p>
					<h5 class="card-title ">ارسال‌های دوستان</h5>
					<a href="#" class="m-left tgju-btn tgju-btn-primary" v-tooltip.bottom="'افزودن به داشبورد'" @click.prevent="addWidget('friend-posts')"><i class="uil uil-plus-circle"></i> افزودن</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'WidgetsModal',
		components: {},
		data: function () {
			return {

			}
		},

		mounted() {

		},

		methods: {
			addWidget(type) {
				this.$parent.emitData('addWidget', {type});
			}
		},
	}
</script>